import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { Card, Alert, Spinner } from 'react-bootstrap';
import history from '../../services/history';
import { exchangeAuthCode, getVidaasStatus } from '../../services/vidaasV2';

// TODO: testar o fluxo VIDAAS completo (como nos providers KYC da LV que falei no TLC)
export default function Tokenizer() {
  const profile = useSelector(state => state.doctor.profile);
  const processedRef = useRef(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);
  const [authorizedIdentification, setAuthorizedIdentification] = useState(
    null
  );
  const searchParams = new URLSearchParams(history.location.search);
  const oauthCode = searchParams.get('code');
  const oauthState = searchParams.get('state');

  useEffect(() => {
    if (!oauthCode || processedRef.current) {
      return;
    }

    processedRef.current = true;
    setError(null);

    const handleExchange = async () => {
      try {
        await exchangeAuthCode({ code: oauthCode, state: oauthState });
        const status = await getVidaasStatus();
        if (status && status.authorizedIdentification) {
          setAuthorizedIdentification(status.authorizedIdentification);
        }
        setSuccess(true);
      } catch (err) {
        setError(
          err?.response?.data?.error || 'Erro ao autenticar com VIDAAS!'
        );
      }
    };

    handleExchange();
  }, [oauthCode, oauthState]);

  if (!oauthCode) {
    return (
      <Card className="d-none d-lg-block">
        <Card.Header>Certificação Digital com VIDAAS</Card.Header>
        <Card.Body>
          <Alert variant="info" role="status">
            Nenhum retorno de autorização foi recebido. Use
            &quot;Autenticar&quot; no menu para iniciar o fluxo com o
            certificado digital.
          </Alert>
        </Card.Body>
      </Card>
    );
  }

  return (
    <Card className="d-none d-lg-block">
      <Card.Header>Certificação Digital com VIDAAS</Card.Header>
      <Card.Body>
        {error ? (
          <Alert variant="danger" role="alert">
            {error}
          </Alert>
        ) : !success ? (
          <div className="text-center py-4">
            <Spinner animation="border" variant="success" role="status">
              <span className="sr-only">Confirmando certificado…</span>
            </Spinner>
            <p className="mt-3 mb-0 text-muted">
              Confirmando autenticação com o certificado digital…
            </p>
          </div>
        ) : (
          <blockquote className="blockquote mb-0">
            <p>
              Olá <strong>{profile.apelido}</strong>,{' '}
            </p>
            <p>
              Sua autenticação com <strong>Certificado Digital</strong> foi
              realizada com sucesso.
            </p>
            {authorizedIdentification && (
              <p className="mb-0">
                CPF autorizado: {authorizedIdentification}
              </p>
            )}
            <p className="mt-3">
              Por favor, prossiga com suas operações de maneira segura e
              confiável. Caso tenha alguma dúvida ou precise de assistência, não
              hesite em contatar nossa equipe de suporte.
            </p>
            <p>
              Agradecemos por utilizar nossos serviços com Segurança e
              Confiança.
            </p>
            <p> Atenciosamente, </p>
            <footer className="blockquote-footer">
              Instituto do Coração de Marília{' '}
              <cite title="Source Title"> - ICM</cite>
            </footer>
          </blockquote>
        )}
      </Card.Body>
    </Card>
  );
}
